<template>
  <div class="db">
    <div class="searchtop">
      <img class="search-left" src="../assets/title-shujk.png" alt />
      <div class="search-right">
            <div class="search-select">
    <el-select class="search" v-model="value" >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
      <el-input
        class="input"
        v-model="input"
        @keyup.enter.native="onSubmit()"
        placeholder="请输入内容"
      ></el-input>
      <img style="width: 27px;height: 27px;margin-top: 7px;margin-left: 297px;position: absolute;z-index: 1;cursor: pointer;" @click="searchlst()" src="../assets/pic-search-red.png" />
    </div>
      </div>
    </div>

    <div :class="[isActive ? 'hid' : '']">
   
      <div class="dblist">
        <router-link
          class="dbblock"
          v-for="(item,index) in dblist"
          :key="index"
          tag="div"
          :to="{ name: 'dbdetails', query: { id: item.ID } }"
        >
          <img :src="$store.state.baseurl + item.coversmail" alt />
          <div class="d-title">{{ item.name }}</div>
          <div class="d-title2">资源条目数：{{ item.resvol }}</div>
          <div class="d-title2">适用对象：专业研究者</div>
          <div style="position: absolute;margin-left: 310px;margin-top: 280px;cursor: pointer;">进入 ></div>
        </router-link>
      </div>

      <div class="page">
        <div>
          <el-pagination
            :background="true"
            layout="prev, pager, next"
          
            :current-page.sync="currentPage"
            :page-size="12"
            :total="dataSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <div  class="search-div" :class="[!isActive ? 'hid' : '']">
   
      <div class="db-results">
        <el-button
        @click="cktitle(item)"
          v-for="(item,index) in selectedArray"
          :key="index"
          class="results-btn"
          type="primary"
          >{{ item }}</el-button
        >
      </div>


      <div class="page">
        <el-pagination
          :background="true"
          layout="prev, pager, next"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          :page-size="10"
          :total="dataSize"
        >
        </el-pagination>
      </div>
    
    </div>
    
  </div>
</template>

<script>


import { Loading } from 'element-ui';
export default {
  name: "app",
  data() {
    return {
      dataSize: 0,
      currentPage: 1,
      isActive: false,
      options: [
        { value: "1", label: "条目" },
        { value: "2", label: "全文" },
      ],
      value: "",
      input: "",
      page: 1,
      selectedArray: [],
      selectedArray1: [],
      lableID:[],
      dblist: [],
      gatherlist: [],
      loading: true,
      ponm1:''
    };
  },
  methods: {
    // 回车键
    onSubmit(msg) {
      let ddown = this.value;  //下拉选择的值
      let input = this.input;  //输入框的值
      this.$router.push({ path: "/view/dbentry" , query:{ddown:ddown,input:input}});
    },
    goto(id){
      window.location.href = 'http://zhdd.qiushifang.com/details.aspx?id=' + id
    },
 
    // 点击标签
    cktitle(msg) {
       var ponm = this.judge(msg);
       if(ponm == 0){
       this.searchlist(ponm,this.input,1)
       this.ponm1 = ponm;
       }else {
       this.searchlist(ponm,this.input,1)
       this.ponm1 = ponm;
       }

    },
    //搜索键
    searchlst(msg){
      console.log("点击搜索" );
      let ddown = this.value;  //下拉选择的值
      let input = this.input;  //输入框的值
      this.$router.push({ path: "/view/dbentry" , query:{ddown:ddown,input:input}});
    },
    handleCurrentChange(page) {
      console.log('测试' ,page)
      this.currentPage = page;
      this.searchlist(this.ponm1,this.input,page)
    },
    //读取下拉菜单选项
    judge(tit) {
      
      for(var i=0;i<this.options.length;i++){
        if(tit == this.options[i].name){
          return this.options[i].label
        }
      }
      return this.options[0].label
    },

    //选项
    selectAll() {
      // console.log("selectAll-"+val)
      this.loading = true;
      if (this.selectedArray.length < this.options.length) {
        this.selectedArray = [];
      
        this.options.map((item) => {
          this.selectedArray.push(item.name);
        });
        // var opt = new Object();
        // opt.name = "全选"
        // opt.label = "0"
        // this.selectedArray.unshift(opt);
        this.selectedArray.unshift("全选");
      } else {
        this.selectedArray = [];
      }
    },
    changeSelect(val) {
      console.log("val-"+val)
      if (!val.includes("全选") && val.length === this.options.length) {
console.log("val2取消全选"+val)
        //  var opt = new Object();
        // opt.name = "全选"
        // opt.label = "0"
        // this.selectedArray.unshift(opt);
        this.selectedArray.unshift("全选");
      } else if (val.includes("全选") && val.length - 1 < this.options.length) {
console.log("val3点击全选"+val)
        this.selectedArray = this.selectedArray.filter((item) => {
          return item !== "全选";
        });
      }
    },
    removeTag(val) {
      console.log("val1"+ val)
      if (val === "全选") {
        this.selectedArray = [];
      }
    },
    //更新列表
    searchlist(id,title,page) {
      // this.startLoading();
      let options = { fullscreen: true }
      let loadingInstance = Loading.service(options);
      setTimeout(() => {
          loadingInstance.close();
        }, 3000);
      Loading.service(options);
      this.$http.get(`${global.BASE_URL}/api/getDblist?id=${id}&title=${title}&page=${page}`).then((res) => {
            // console.log("-------",res.data)
            const json = res.data;
            const obj = JSON.parse(json);
            this.gatherlist = obj.dbdata
            // console.log("结果" + obj.number)
            this.dataSize = obj.number
         
             loadingInstance.close();
            return obj.number
      });
    },
  },

  created() {
    this.$http
      .get(`${global.BASE_URL}/api/dblist?page=${this.page}`)
      .then((res) => {
        const json = res.data;
        const obj = JSON.parse(json);
        console.log(obj.dbinfo);
        this.dblist = obj.dbinfo;
        this.bookinfo = obj.ebookInfo;
      });
  },
};
</script>

<style scoped lang="scss">
.hid {
  display: none;
}
element.style {
  top: 167px !important;
} 

.db {
  background-color: #f0f0f0;
}
.search-select {
  width: 590px;
  display: flex;
  justify-content: center;
  
  .input {
    border-radius: 0px;
    width: 242px;
    height: 44px;
  }
  .search {
    border-radius: 0px;
    height: 48px;
    width: 100px;
    input.el-input__inner {
    border-radius: 0px;
    height: 44px !important; 
    width: 150px !important;
    padding: 0 30px 0 15px !important;
  }
  }
}

.el-select__tags-text{
  width: 24px !important;
}


.searchtop {
  width: 1200px;
  padding-top: 20px;
  margin: auto;
  display: flex;
  flex-direction: row;
  .search-left{
    left: 0px;
    width: 272px;
    height: 61px;
  }
  .search-right{
    margin-left: 450px;
  }
}


.dblist {
  width: 1200px;
  margin: auto;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  .dbblock {
    width: 380px;
    height: 320px;
    margin: 10px;
    background-color: #ffffff;
    // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
    text-align: left;
    div {
      margin-left: 10px;
      margin-top: 10px;
    }
    .d-title {
      float: left;
      margin-top: 13px;
      font-size: 16px;
    }
    .d-title2 {
      font-size: 13px;
      color: #666666;
    }
    .d-crowd {
      float: left;
      margin-top: 20px;
      font-size: 13px;
      span {
        margin-right: 15px;
        background-color: #e3e3e3;
        padding: 5px 10px;
        border-radius: 30px;
      }
    }
  }
  .dbblock:hover {
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
    .d-title {
      color: #de1c31;
      text-decoration: underline;
    }
  }
}
.page {
  width: 1200px;
  margin: 0 auto;
  padding: 50px;
  text-align: right;
  .active  {
    background-color: #7b112c !important;
  }
}

// ****检索页面*****
.search-div {
  width: 1200px;
  margin: auto;
  .db-results {
    display: flex;
    flex-wrap: wrap;
    .results-btn {
      margin: 20px 20px 10px 20px;
    }
  }
}

.db-list {
  margin-top: 20px;
  padding-bottom: 20px;

  .db-frame {
    display: block;
    padding: 10px;
    margin-top: 20px;
    background-color: #ffffff;
    text-align: left;
    .db-title {
      font-weight: bold;
    }
    p {
      text-align: left;
    }
  }
}

</style>
